var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Reports", path: { name: "admin-reports" } }],
          name: "Sales by Category",
          title: _vm.pageTitle,
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "d-flex justify-content-between" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        { staticClass: "mr-3" },
                        [
                          _c("strong", { staticClass: "text-uppercase" }, [
                            _vm._v("Start Date:"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.startDate) + "\n            "
                          ),
                          _c("b-form-datepicker", {
                            staticClass: "ml-2",
                            attrs: {
                              max: _vm.maxDate,
                              "button-only": "",
                              "button-variant": "primary",
                            },
                            on: { input: _vm.onStartDateChanged },
                            model: {
                              value: _vm.filters.start_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "start_date", $$v)
                              },
                              expression: "filters.start_date",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("strong", { staticClass: "text-uppercase" }, [
                            _vm._v("End Date:"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.endDate) + "\n            "),
                          _c("b-form-datepicker", {
                            staticClass: "ml-2",
                            attrs: {
                              max: _vm.maxDate,
                              "button-only": "",
                              "button-variant": "primary",
                            },
                            on: { input: _vm.onEndDateChanged },
                            model: {
                              value: _vm.filters.end_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "end_date", $$v)
                              },
                              expression: "filters.end_date",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "primary",
                              title: "Download CSV",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.downloadCsv.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-download")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "primary",
                              title: "Reset Filters",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.resetFilters.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-arrow-counterclockwise")],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-table", {
            attrs: {
              fields: _vm.reportColumns,
              items: _vm.reportRows,
              "table-class": "text-nowrap",
              responsive: "",
              hover: "",
            },
            scopedSlots: _vm._u([
              {
                key: "cell(main_column)",
                fn: function (data) {
                  return [
                    typeof data.item.category_type_id !== "undefined"
                      ? [
                          _c(
                            "b-link",
                            {
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return (() => {
                                    _vm.filters.category_type =
                                      data.item.category_type_id
                                    _vm.loadReportData()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(data.item.main_column) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      : typeof data.item.category_id !== "undefined"
                      ? [
                          _c(
                            "b-link",
                            {
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return (() => {
                                    _vm.filters.category = data.item.category_id
                                    _vm.loadReportData()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(data.item.main_column) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      : [_vm._v(_vm._s(data.item.main_column))],
                    _vm._v(" "),
                    typeof data.item.is_total !== "undefined"
                      ? [
                          _vm.category
                            ? _c(
                                "b-link",
                                {
                                  staticClass: "text-danger",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return (() => {
                                        _vm.filters.category = null
                                        _vm.loadReportData()
                                      }).apply(null, arguments)
                                    },
                                  },
                                },
                                [_vm._v("\n            clear\n          ")]
                              )
                            : _vm.category_type
                            ? _c(
                                "b-link",
                                {
                                  staticClass: "text-danger",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return (() => {
                                        _vm.filters.category_type = null
                                        _vm.loadReportData()
                                      }).apply(null, arguments)
                                    },
                                  },
                                },
                                [_vm._v("\n            clear\n          ")]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }